import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import './OutputTab.css';

interface OutputTabProps {
  outputs: string[];
  onClear?: () => void;
}

const OutputTab: React.FC<OutputTabProps> = ({ outputs, onClear }) => {
  const { t } = useTranslation();

  return (
    <div className="output-tab-container">
      <div className="output-tab-toolbar">
        <select className="output-select">
          <option value="all">{t('output.allChannels', 'All Channels')}</option>
          <option value="app">{t('output.application', 'Application')}</option>
          <option value="build">{t('output.build', 'Build')}</option>
          <option value="debug">{t('output.debug', 'Debug')}</option>
        </select>
        {onClear && (
          <button className="output-clear-btn" onClick={onClear} title={t('output.clear', 'Clear Output')}>
            <FaTimes size={12} />
          </button>
        )}
      </div>
      <div className="output-tab-content">
        {outputs.length === 0 ? (
          <div className="output-empty">
            {t('output.noOutput', 'No output yet...')}
          </div>
        ) : (
          outputs.map((line, index) => (
            <div key={index} className="output-line">{line}</div>
          ))
        )}
      </div>
    </div>
  );
};

export default OutputTab;
